"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = trackMeaningExpansion;
var _state = require("@seedlang/state");
function trackMeaningExpansion(word, meaning) {
  _state.AppUI.createEvent('vocab - expand meaning', {
    word_id: word.id,
    meaning_id: meaning.id,
    language_id: word.languageId
  });
}